import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-colorado-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./colorado-state-form.component.html",
  styleUrl: "./colorado-state-form.component.scss",
})
export class ColoradoStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
